import { useEffect, useLayoutEffect } from 'react'
import { useNavigate, Outlet, useLocation } from 'react-router-dom'
import { setCommittedLocationKey } from '../../helpers/committedLocation'
import { setNavigateFunction } from '../../redux/navigationHelper'

const NavigationSetup = () => {
  const navigate = useNavigate()
  const { key } = useLocation()

  useEffect(() => {
    setNavigateFunction(navigate)
  }, [navigate])

  useLayoutEffect(() => {
    setCommittedLocationKey(key)
  }, [key])

  return <Outlet />
}

export default NavigationSetup
